import ReactPlayer from "react-player";
import user from "../../assests/user.svg";
import AudioPlayerWithoutDownload from "../AudioPlayerWithoutDownload/AudioPlayerWithoutDownload";
import styles from "./EntryView.module.css";
import Lottie from "react-lottie-player";
import { Link, createSearchParams } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import Context from "../../context/Context";
import SharePopup from "../SharePopup/SharePopup";
import axios from "axios";
import { isEmpty } from "lodash";
import positionOne from "../../assests/winner/positionOne.svg";
import positionTwo from "../../assests/winner/positionTwo.svg";
import positionThree from "../../assests/winner/positionThree.svg";
import CustomVideoPlayer from "../CustomVideoPlayer/CustomVideoPlayer";
import { useUserAuth } from "../../context/UserAuthContext";

export default function EntryView({ data, likeMap }) {
  const [share, setShare] = useState(false);
  const [readMore, setReadMore] = useState(false);
  const [formAttr, setFormAttr] = useState({});
  const { searchParams, newUserId } = useUserAuth();
  const userId = localStorage.getItem("userId");
  let userIdFromLocalOrApi = newUserId || userId;

  useEffect(() => {
    if (readMore) {
      loadFormAttributes();
    } else {
      setFormAttr({});
    }
  }, [readMore]);
  const getProfilePic = () => {
    let url = `https://storage.googleapis.com/goviralprofiledatas/${data?.uid}`;
    return url;
  };
  const { showcaseScrollPositionRef, isMobile, setReportErrorPopup } =
    useContext(Context);
  const handleRecordScroll = () => {
    showcaseScrollPositionRef.current = window.scrollY;
  };
  function ShareHandle() {
    if (isMobile) {
      let copyText = "";
      if (userIdFromLocalOrApi) {
        copyText =
          "https://share.goviralit.com" +
          "/vidu" +
          userIdFromLocalOrApi +
          "o" +
          data?.orgId +
          "cp" +
          data?.campaignId +
          "cn" +
          data?.contestId +
          "e" +
          data?.entryId;
      } else {
        copyText =
          "https://share.goviralit.com" +
          "/vid" +
          "o" +
          data?.orgId +
          "cp" +
          data?.campaignId +
          "cn" +
          data?.contestId +
          "e" +
          data?.entryId;
      }

      if (window.messageHandler) {
        window.messageHandler.postMessage(
          JSON.stringify({
            url: copyText,
            imageUrl: data?.qrCodeUrl,
          })
        );
      } else {
        alert("Flutter messageHandler not found!");
      }
      return;
    }
    setShare((prev) => !prev);
  }
  const loadFormAttributes = async () => {
    try {
      const dataFromJson = await axios.get(
        `${process.env.REACT_APP_FORM_ATTRIBUTES}/${data?.orgId}/${data?.campaignId}/${data?.contestId}/formAttributes.json`
      );
      setFormAttr(dataFromJson?.data);
    } catch (error) {
      console.log(error.message);
      //navigate("/error")
    }
  };

  const handleReadMore = () => {
    setReadMore((prev) => !prev);
  };
  return (
    <div>
      {share && (
        <SharePopup
          showShare={ShareHandle}
          contestant={{ ...data, _id: data?.entryId }}
        />
      )}
      <div className="w-full flex items-center justify-between pr-[20px]">
        <div className={styles.header}>
          <div>
            <img
              src={getProfilePic()}
              alt={data?.participantName}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = user;
              }}
            />
          </div>
          <div>
            <h3>{data?.participantName}</h3>
            <p>
              Participated in{" "}
              <Link
                to={{
                  pathname: `/${data?.orgDomain}/${data?.campaignUniqueText}/${data?.contestUniqueText}.html`,
                  search: `${
                    searchParams ? createSearchParams(searchParams) : ""
                  }`,
                }}
              >
                <span onClick={handleRecordScroll}>{data?.contestName}</span>
              </Link>
            </p>
          </div>
        </div>
        {isMobile && (
          <p
            onClick={() => setReportErrorPopup(true)}
            className="text-regular text-[#FA6B6B] cursor-pointer whitespace-nowrap"
          >
            Report and Block
          </p>
        )}
      </div>

      <div className={styles.entryContainer}>
        {data?.fileUrls?.map((obj, index) => {
          return (
            <div
              className={`h-full w-full flex items-center justify-center relative shrink-0 snap-start`}
              style={{
                background: `url(${
                  obj.fileType?.startsWith("video")
                    ? data?.thumbnailUrl
                    : obj.fileUrl
                }) center center/cover no-repeat`,
              }}
              key={index}
            >
              <div className={styles.imageBg}>
                {obj.fileType?.startsWith("video") && (
                  <CustomVideoPlayer
                    fileUrl={obj.fileUrl}
                    thumbnail={data?.thumbnailUrl}
                  />
                )}
                {obj.fileType?.startsWith("image") && (
                  <img
                    src={obj.fileUrl}
                    alt=""
                    className={`h-[100%] w-[100%] mx-auto object-contain `}
                  />
                )}
                {obj.fileType?.startsWith("audio") && (
                  <div className="h-full p-[20px] ">
                    <img
                      src={data?.thumbnailUrl}
                      className={`h-[80%] w-[100%] mx-auto object-contain mb-[10px]`}
                    />
                    <AudioPlayerWithoutDownload
                      fileUrl={obj?.fileUrl}
                      fileName="my voice recording"
                    />
                  </div>
                )}
              </div>

              {data?.fileUrls && data?.fileUrls?.length > 1 && (
                <p className={styles.entryNumbers}>
                  {index + 1} / {data?.fileUrls?.length}
                </p>
              )}
            </div>
          );
        })}
        {data?.winner && (
          <div className={styles.winnerBadge}>
            {data?.winnerObject?.position == 1 && <img src={positionOne} />}
            {data?.winnerObject?.position == 2 && <img src={positionTwo} />}
            {data?.winnerObject?.position == 3 && <img src={positionThree} />}
          </div>
        )}
      </div>
      <div className={styles.footer}>
        <Link
          to={{
            pathname: `/${data?.orgDomain}/${data?.campaignUniqueText}/${data?.contestUniqueText}.html`,
            search: `${searchParams ? createSearchParams(searchParams) : ""}`,
          }}
        >
          <div
            className="w-full py-[13px] px-[20px]"
            style={{ background: data?.buttonColor || "#FF502A" }}
            onClick={handleRecordScroll}
          >
            <h3>Participate Now</h3>
          </div>
        </Link>
        <div className="py-[16px] px-[20px]">
          <div className="flex items-center justify-between mb-[12px]">
            <h4>{data?.likesCount} Votes</h4>
            <div
              className="w-[32px] h-[32px] cursor-pointer"
              onClick={ShareHandle}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.2538 16.8614L10.2565 15.8627C7.11914 14.8174 5.5498 14.2947 5.5498 13.3334C5.5498 12.3734 7.11914 11.8494 10.2565 10.8041L21.6071 7.02006C23.8151 6.28406 24.9191 5.91606 25.5018 6.49872C26.0845 7.08139 25.7165 8.18539 24.9818 10.3921L21.1965 21.7441C20.1511 24.8814 19.6285 26.4507 18.6671 26.4507C17.7071 26.4507 17.1831 24.8814 16.1378 21.7441L15.1378 18.7481L20.9431 12.9427C21.186 12.6913 21.3204 12.3545 21.3174 12.0049C21.3143 11.6553 21.1741 11.3208 20.9269 11.0736C20.6797 10.8264 20.3453 10.6862 19.9957 10.6832C19.6461 10.6801 19.3093 10.8145 19.0578 11.0574L13.2538 16.8614Z"
                  fill="#161616"
                />
              </svg>
            </div>
          </div>
          <div className=" cursor-pointer" onClick={handleReadMore}>
            <p>
              <span className="font-semibold">{data?.participantName}</span>{" "}
              {readMore ? data?.description : data?.description?.slice(0, 88)}
              <span className="text-[#8F8F8F]">
                {readMore ? "" : "...Read More"}
              </span>
            </p>
            {!isEmpty(formAttr?.formAttributes) && (
              <div className="mt-[20px]">
                {formAttr?.formAttributes?.map((el) => {
                  return (
                    <div className="flex flex-col gap-[30px]">
                      {el?.items?.map((key) => {
                        if (data[key] && el?.display) {
                          if (el.attrType == "media") {
                            return (
                              <div className="pb-[20px]">
                                <p
                                  className=" mb-[6px]"
                                  style={{ fontWeight: 600 }}
                                >
                                  {el?.title}{" "}
                                </p>
                                {el?.type?.startsWith("image") && (
                                  <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                                    <img
                                      src={data[key]}
                                      className="w-auto h-[100%]"
                                    />
                                  </div>
                                )}
                                {el?.type?.startsWith("video") && (
                                  <div className="h-[320px] w-[100%] overflow-hidden flex items-center justify-center mb-[15px] bg-[#1c1c1c]">
                                    <ReactPlayer
                                      playing={false}
                                      controls={true}
                                      width="100%"
                                      height="100%"
                                      url={data[key]}
                                      style={{ objectFit: "contain" }}
                                    />
                                  </div>
                                )}
                              </div>
                            );
                          } else {
                            return (
                              <div className="pb-[20px]">
                                <p
                                  className=" mb-[6px]"
                                  style={{ fontWeight: 600 }}
                                >
                                  {el?.title}{" "}
                                </p>
                                <p className="">{data[key]}</p>
                              </div>
                            );
                          }
                        }
                      })}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <Link
            to={{
              pathname: `/${data?.orgDomain}/${data?.campaignUniqueText}.html`,
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            }}
          >
            <button
              style={{ background: data?.buttonColor || "#FF502A" }}
              onClick={handleRecordScroll}
              className="mt-[20px]"
            >
              View Campaign
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="6"
                height="11"
                viewBox="0 0 6 11"
                fill="none"
              >
                <path
                  d="M0.225013 10.3291C0.355213 10.4528 0.526113 10.5113 0.737713 10.5048C0.949246 10.4983 1.12338 10.43 1.26011 10.2998L5.3324 6.4619C5.5147 6.29264 5.63677 6.0908 5.69861 5.8564C5.76047 5.62203 5.76047 5.38766 5.69861 5.15328C5.63677 4.9189 5.5147 4.71708 5.3324 4.54781L1.26011 0.719682C1.11038 0.576456 0.936246 0.501586 0.737713 0.495072C0.539113 0.488566 0.371446 0.553669 0.234713 0.690382C0.0849791 0.827102 0.00687981 0.999629 0.000412941 1.20796C-0.0061202 1.4163 0.0654793 1.59208 0.215213 1.73531L4.22889 5.50484L0.215213 9.2841C0.0720129 9.42084 0.000412941 9.59337 0.000412941 9.8017C0.000412941 10.01 0.0752792 10.1858 0.225013 10.3291Z"
                  fill="black"
                />
              </svg>
            </button>
          </Link>
        </div>
      </div>

      {/* <p>Entry Id : {data?.entryId}</p>
      <p>Like count : {likeMap.get("con" + data?.entryId)?.likesCount}</p>
      <p>Liked : {likeMap.get("con" + data?.entryId)?.liked}</p> */}
    </div>
  );
}
